export default __webpack_public_path__ + "static/media/autonomy_n_full.99e8864a.svg";